import { request } from './api';

function sanitizeBaseUrl(value) {
  const raw = String(value || '').trim().replace(/\/+$/, '');
  if (!raw) return '';
  try {
    const parsed = new URL(raw);
    if (parsed.protocol === 'http:' || parsed.protocol === 'https:') return parsed.origin;
  } catch (_) {}
  return '';
}

const contactsService = {
  // Buscar todos os contatos
  async getContacts(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await request(`/api/contacts${queryParams ? `?${queryParams}` : ''}`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar contatos:', error);
      throw error;
    }
  },

  // Buscar contato por ID
  async getContactById(id) {
    try {
      const response = await request(`/api/contacts/${id}`);
      return response;
    } catch (error) {
      console.error('Erro ao buscar contato:', error);
      throw error;
    }
  },

  // Criar novo contato
  async createContact(contactData) {
    try {
      const response = await request('/api/contacts', {
        method: 'POST',
        body: JSON.stringify(contactData)
      });
      return response;
    } catch (error) {
      console.error('Erro ao criar contato:', error);
      throw error;
    }
  },

  // Atualizar contato
  async updateContact(id, contactData) {
    try {
      const response = await request(`/api/contacts/${id}`, {
        method: 'PUT',
        body: JSON.stringify(contactData)
      });
      return response;
    } catch (error) {
      console.error('Erro ao atualizar contato:', error);
      throw error;
    }
  },

  // Deletar contato
  async deleteContact(id) {
    try {
      const response = await request(`/api/contacts/${id}`, {
        method: 'DELETE'
      });
      return response;
    } catch (error) {
      console.error('Erro ao deletar contato:', error);
      throw error;
    }
  },

  // Importar contatos
  async importContacts(file) {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await request('/api/contacts/import', {
        method: 'POST',
        body: formData,
        headers: {} // Remove Content-Type para FormData
      });
      return response;
    } catch (error) {
      console.error('Erro ao importar contatos:', error);
      throw error;
    }
  }
  ,
  async exportContacts(params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    const base = sanitizeBaseUrl(localStorage.getItem('apiBaseUrl'))
      || sanitizeBaseUrl(process.env.REACT_APP_API_URL)
      || sanitizeBaseUrl(window.location.origin);
    const userData = localStorage.getItem('vortiqaUser');
    const token = userData ? JSON.parse(userData).token : null;
    const resp = await fetch(`${base}/api/contacts/export${queryParams ? `?${queryParams}` : ''}`, {
      method: 'GET',
      headers: token ? { Authorization: `Bearer ${token}` } : {}
    });
    if (!resp.ok) {
      const text = await resp.text().catch(() => '');
      throw new Error(text || `Erro HTTP ${resp.status}`);
    }
    const blob = await resp.blob();
    return blob;
  },
  async getContactTimeline(id) {
    return request(`/api/contacts/${id}/timeline`);
  },
  async getContactTickets(id, params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return request(`/api/contacts/${id}/tickets${queryParams ? `?${queryParams}` : ''}`);
  },
  async getContactMessages(id, params = {}) {
    const queryParams = new URLSearchParams(params).toString();
    return request(`/api/contacts/${id}/messages${queryParams ? `?${queryParams}` : ''}`);
  },
  async getSegments() {
    return request('/api/contacts/segments');
  }
};

export default contactsService;
